module.exports = __webpack_public_path__ + "img/languageIcon.268f80e5.svg";